import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import imageIcon from "../../Assets/images/VoxApp-Icon.png";
import { BackBtn } from "../../Assets/svgs/BackButton";
import HamburgerIcon from "../../Assets/svgs/HamburgerIcon";
import { LockIconSmall } from "../../Assets/svgs/LockIconSmall";
import { getUserData } from "../../Common/utils";
import { getCountCreditAvailable } from "../../Redux/Slice/Dashboard/CustomerDashboard/GetCountCreditAvailableSlice";
import CreditIcon from "../../Assets/svgs/CreditIcon";

export const Header = ({ onClickHamburgerIcon, openSidebar }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const modalref = useRef();
  const [headerTitle, setHeaderTitle] = useState("Dashboard");
  const currentUserData = useSelector((s) => s?.currentUser?.userData);
  const userData = currentUserData ? currentUserData : getUserData();
  const [openDropdown, setOpenDropdown] = useState(false);
  const { creditAvailableData } = useSelector((s) => s?.countCreditAvailable);
  const availableCredit = parseInt(
    creditAvailableData?.data?.creditsAvailable ?? 0
  ).toLocaleString();
  const setHeader = () => {
    if (location.pathname.includes("dashboard")) {
      setHeaderTitle("Dashboard");
    } else if (
      location.pathname.includes("subscription-payment") ||
      location.pathname.includes("additional-assistant-payment")
    ) {
      setHeaderTitle("Payments");
    } else if (location.pathname.includes("edit-subscription-plan")) {
      setHeaderTitle("Manage Subscription Plan");
    } else if (location.pathname.includes("add-subscription-plan")) {
      setHeaderTitle("Add New Subscription Plan");
    } else if (location.pathname.includes("edit-topup-plan")) {
      setHeaderTitle("Manage Topup Plan");
    } else if (location.pathname.includes("add-topup-plan")) {
      setHeaderTitle("Add New Topup Plan");
    } else if (location.pathname.includes("subscription")) {
      setHeaderTitle("Plans");
    } else if (location.pathname.includes("edit-user")) {
      setHeaderTitle("Edit User");
    } else if (location.pathname.includes("add-user")) {
      setHeaderTitle("Add User");
    } else if (location.pathname.includes("user")) {
      setHeaderTitle("Users");
    } else if (location.pathname.includes("edit-customer")) {
      setHeaderTitle("Edit Customer");
    } else if (location.pathname.includes("add-customer")) {
      setHeaderTitle("Add Customer");
    } else if (location.pathname.includes("customerbilling")) {
      setHeaderTitle("Billing");
    } else if (location.pathname.includes("customer")) {
      setHeaderTitle("Customers");
    } else if (location.pathname.includes("add-plan-type")) {
      setHeaderTitle("Add Plan Type");
    } else if (location.pathname.includes("edit-plan-type")) {
      setHeaderTitle("Edit Plan Type");
    } else if (location.pathname.includes("plan-type")) {
      setHeaderTitle("Plan Type");
    } else if (location.pathname.includes("plan")) {
      setHeaderTitle("Plans");
    } else if (location.pathname.includes("assistant/documents")) {
      setHeaderTitle("Documents");
    } else if (location.pathname.includes("assistant/form-submissions")) {
      setHeaderTitle("Forms");
    } else if (location.pathname.includes("assistant/functions")) {
      setHeaderTitle("Functions");
    } else if (location.pathname.includes("assistant/knowledge-base")) {
      setHeaderTitle("Knowledge Base");
    } else if (location.pathname.includes("view-assistants")) {
      setHeaderTitle("View Assistant");
    } else if (location.pathname.includes("chat")) {
      setHeaderTitle("Chats");
    } else if (location.pathname.includes("meta-assistant")) {
      setHeaderTitle("Meta Assistant");
    } else if (location.pathname.includes("add-assistant-builder")) {
      setHeaderTitle("Create Assistant");
    } else if (location.pathname.includes("assistant")) {
      setHeaderTitle("Assistants");
    } else if (location.pathname.includes("addPayment")) {
      setHeaderTitle("Payments");
    } else if (location.pathname.includes("profile")) {
      setHeaderTitle("Account Information");
    } else if (location.pathname.includes("change-password")) {
      setHeaderTitle("Change Password");
    } else if (location.pathname.includes("transaction-history")) {
      setHeaderTitle("Transaction History");
    } else if (location.pathname.includes("contacts")) {
      setHeaderTitle("Contacts");
    } else if (location.pathname.includes("add-contact")) {
      setHeaderTitle("Add Contact");
    } else if (location.pathname.includes("edit-contact")) {
      setHeaderTitle("Edit Contact");
    } else if (location.pathname.includes("add-group")) {
      setHeaderTitle("Add Group");
    } else if (location.pathname.includes("edit-group")) {
      setHeaderTitle("Edit Group");
    } else if (location.pathname.includes("group-members")) {
      setHeaderTitle("Group");
    } else if (location.pathname.includes("call-email-history")) {
      setHeaderTitle("Call/Email History");
    } else if (
      location.pathname.includes("call") ||
      location.pathname.includes("group-call")
    ) {
      setHeaderTitle("Schedule a call");
    } else if (location.pathname.includes("email")) {
      setHeaderTitle("Schedule an Email");
    } else if (location.pathname.includes("reports")) {
      setHeaderTitle("Reports");
    } else if (location.pathname.includes("phoneNumbers")) {
      setHeaderTitle("Phone Number");
    } else if (location.pathname.includes("integration")) {
      setHeaderTitle("Integration");
    }
  };

  useEffect(() => {
    setHeader();
    document.addEventListener("mousedown", handleClickOutside);
    if (userData?.role?.name === "company") {
      dispatch(getCountCreditAvailable());
    }
  }, [location.pathname]);

  const handleClickOutside = (event) => {
    if (modalref && modalref.current) {
      if (modalref && !modalref.current.contains(event.target)) {
        setOpenDropdown(false);
      }
    }
  };

  return (
    <div className="page__head">
      <h2 className="page__head--title">
        {location.pathname.includes("transaction-history") ||
        location.pathname.includes("customerUser") ||
        location.pathname.includes("group-members") ||
        location.pathname.includes("/call/") ||
        location.pathname.includes("/chat/") ||
        location.pathname.includes("/email/") ||
        location.pathname.includes("/group-call/") ||
        location.pathname.includes("/assistants/") ||
        location.pathname.includes("/add-assistant/") ||
        location.pathname.includes("/add-meta-assistant") ||
        location.pathname.includes("/assistant/form-submission/") ||
        location.pathname.includes("plan-type") ||
        location.pathname.includes("edit-subscription-plan") ||
        location.pathname.includes("add-subscription-plan") ||
        location.pathname.includes("add-topup-plan") ||
        location.pathname.includes("edit-topup-plan") ||
        location.pathname.includes("/group-email/") ? (
          <button
            className="backBtn"
            onClick={() => {
              navigate(-1);
            }}
          >
            {" "}
            <BackBtn />{" "}
          </button>
        ) : (
          ""
        )}{" "}
        {location.pathname.includes("customerUser") &&
        location?.state?.companyName
          ? `Customer - ${location?.state?.companyName}`
          : location.pathname.includes("/assistants/")
          ? `${location?.state?.customerName} - View Assistant`
          : location.pathname.includes("group-members") && location?.state?.name
          ? `Group - ${location?.state?.name}`
          : location?.pathname?.includes("assistant/form-submission/") &&
            location?.state?.name
          ? location?.state?.name
          : headerTitle}
      </h2>
      <div className="page__head__actions">
        {userData?.role?.name === "company" ? (
          <button className="btnCredits">
            <CreditIcon />
            <span className="btnCredits__text">
              {availableCredit}
              <span> Credits</span>
            </span>
          </button>
        ) : null}
        {/* <button className="notificationBtn">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.4419 25C9.28888 25 7.53564 23.2479 7.53564 21.0938C7.53564 20.6625 7.88564 20.3125 8.31689 20.3125C8.74815 20.3125 9.09814 20.6625 9.09814 21.0938C9.09814 22.3866 10.1502 23.4375 11.4419 23.4375C12.7336 23.4375 13.7856 22.3866 13.7856 21.0938C13.7856 20.6625 14.1356 20.3125 14.5669 20.3125C14.9981 20.3125 15.3481 20.6625 15.3481 21.0938C15.3481 23.2479 13.5951 25 11.4419 25Z"
              fill="#0F172A"
            />
            <path
              d="M20.0357 21.875H2.84824C1.84307 21.875 1.02539 21.0573 1.02539 20.0521C1.02539 19.5187 1.25771 19.0136 1.66283 18.6666C1.68896 18.6438 1.717 18.623 1.74618 18.6041C3.2753 17.2697 4.15039 15.35 4.15039 13.3228V10.4166C4.15039 6.39591 7.42226 3.125 11.442 3.125C11.6087 3.125 11.7889 3.12805 11.9556 3.15628C12.3816 3.22704 12.6692 3.63026 12.5982 4.05521C12.5275 4.48017 12.117 4.7678 11.6993 4.69685C11.6159 4.6833 11.5244 4.6875 11.442 4.6875C8.28381 4.6875 5.71289 7.25727 5.71289 10.4166V13.3228C5.71289 15.8396 4.60968 18.2209 2.68898 19.8551C2.67334 19.8677 2.6598 19.8792 2.64301 19.8906C2.61497 19.9261 2.58789 19.9802 2.58789 20.0521C2.58789 20.1937 2.70672 20.3125 2.84824 20.3125H20.0357C20.1775 20.3125 20.2963 20.1937 20.2963 20.0521C20.2963 19.9791 20.2692 19.9261 20.24 19.8906C20.2244 19.8792 20.2108 19.8677 20.1952 19.8551C18.2734 18.2198 17.1713 15.8396 17.1713 13.3228V12.1876C17.1713 11.7563 17.5213 11.4063 17.9525 11.4063C18.3838 11.4063 18.7338 11.7563 18.7338 12.1876V13.3228C18.7338 15.3511 19.6098 17.2718 21.1411 18.6073C21.1691 18.626 21.1962 18.6459 21.2212 18.6678C21.6265 19.0136 21.8588 19.5187 21.8588 20.0521C21.8588 21.0573 21.0411 21.875 20.0357 21.875Z"
              fill="#0F172A"
            />
            <path
              d="M18.7338 10.4166C15.8619 10.4166 13.5254 8.08029 13.5254 5.2084C13.5254 2.3365 15.8619 0 18.7338 0C21.6057 0 23.942 2.3365 23.942 5.2084C23.942 8.08029 21.6057 10.4166 18.7338 10.4166ZM18.7338 1.5625C16.7233 1.5625 15.0879 3.19786 15.0879 5.2084C15.0879 7.21874 16.7233 8.8541 18.7338 8.8541C20.7441 8.8541 22.3795 7.21874 22.3795 5.2084C22.3795 3.19786 20.7441 1.5625 18.7338 1.5625Z"
              fill="#FE5C73"
            />
          </svg>
        </button> */}
        <div className="userProfile">
          <button
            className="userProfile__link"
            onClick={() => setOpenDropdown(true)}
          >
            <span className="picIcon">
              <img
                className="picIcon__img"
                src={userData?.avatar ? userData?.avatar : imageIcon}
                alt=""
              />
            </span>
            <div className="userProfile__link__detail">
              <h3 className="name">
                {userData?.firstName} {userData?.lastName}
              </h3>
              {userData?.customer?.companyName ? (
                <p className="para">{userData?.customer?.companyName}</p>
              ) : null}
            </div>
          </button>
          {openDropdown ? (
            <div
              className="userProfile__dropdown userProfile__dropdown--open"
              ref={modalref}
            >
              <ul className="userdetials">
                <li className="userdetials__item">
                  <div className="pic">
                    {/* <!-- <img className="pic__img" src="../images/user-profile-img.png" alt="" /> --> */}
                    <img
                      className="pic__img"
                      src={userData?.avatar ? userData?.avatar : imageIcon}
                      alt=""
                    />
                  </div>
                  <div className="userdetials__item__detail">
                    <h3 className="name">
                      {" "}
                      {userData?.firstName} {userData?.lastName}
                    </h3>
                    <p className="para"> {userData?.email}</p>
                  </div>
                </li>
                <li
                  className="userdetials__item"
                  onClick={() => {
                    setOpenDropdown(false);
                    navigate("/profile");
                  }}
                >
                  <span className="icon">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.75 0.75C4.75 0.335786 4.41421 0 4 0C3.58579 0 3.25 0.335786 3.25 0.75V2.00879C1.43368 2.13698 0 3.65106 0 5.5V6.5C0 8.34894 1.43368 9.86302 3.25 9.99121L3.25 15.25C3.25 15.6642 3.58579 16 4 16C4.41421 16 4.75 15.6642 4.75 15.25L4.75 9.99121C6.56632 9.86302 8 8.34894 8 6.5V5.5C8 3.65106 6.56632 2.13698 4.75 2.00879V0.75ZM6.5 5.5C6.5 4.39543 5.60457 3.5 4.5 3.5H3.5C2.39543 3.5 1.5 4.39543 1.5 5.5V6.5C1.5 7.60457 2.39543 8.5 3.5 8.5H4.5C5.60457 8.5 6.5 7.60457 6.5 6.5V5.5Z"
                        fill="#000"
                      ></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11.25 0.75L11.25 6.00879C9.43368 6.13698 8 7.65106 8 9.5V10.5C8 12.3489 9.43368 13.863 11.25 13.9912L11.25 15.25C11.25 15.6642 11.5858 16 12 16C12.4142 16 12.75 15.6642 12.75 15.25L12.75 13.9912C14.5663 13.863 16 12.3489 16 10.5V9.5C16 7.65106 14.5663 6.13698 12.75 6.00879L12.75 0.75C12.75 0.335786 12.4142 0 12 0C11.5858 0 11.25 0.335786 11.25 0.75ZM11.5 7.5C10.3954 7.5 9.5 8.39543 9.5 9.5V10.5C9.5 11.6046 10.3954 12.5 11.5 12.5H12.5C13.6046 12.5 14.5 11.6046 14.5 10.5V9.5C14.5 8.39543 13.6046 7.5 12.5 7.5H11.5Z"
                        fill="#000"
                      ></path>
                    </svg>
                  </span>
                  Account Information
                </li>
                <li
                  className="userdetials__item"
                  onClick={() => {
                    setOpenDropdown(false);
                    navigate("/change-password");
                  }}
                >
                  <span className="icon">
                    <LockIconSmall />
                  </span>
                  Change Password
                </li>
              </ul>
            </div>
          ) : (
            ""
          )}
        </div>
        <button
          onClick={onClickHamburgerIcon}
          className="btnCollapse"
          id="sidebarCollapse"
        >
          {openSidebar ? (
            <svg
              width="23"
              height="23"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 1L1 13M1 1L13 13"
                stroke="#fff"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          ) : (
            <HamburgerIcon />
          )}
        </button>
      </div>
    </div>
  );
};
